<div class="alert-card" [ngClass]="type" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

  <mat-icon class="alert-icon">{{ defaultIcon }}</mat-icon>

  <div class="alert-content-wrapper">
    @if(title) {
    <h4 class="alert-title">{{ title }}</h4>
    }

    <div class="alert-body">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="alert-actions">
    <ng-content select="[alertActions]"></ng-content>
  </div>

  @if(closable) {
  <button mat-icon-button class="alert-close-button" (click)="onClose()" type="button">
    <mat-icon>close</mat-icon>
  </button>
  }

  @if(timerDuration > 0) {
  <mat-progress-bar class="alert-progress-bar" mode="determinate" [value]="progressValue">
  </mat-progress-bar>
  }
</div>
